import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import CustomInputHookForm from "@/pages/checkout/components/CustomInput/CustomInputHookForm";
import stl from "./ShopApplyForm.module.css";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
import { useLocation } from "react-router-dom";
import { CDN_LINK, serverUrl } from "@globalConfig";
import { cashCheckout3Event } from "@/utils/dataLayerEvents";
import Tag from "../../../../components/UiKit/Tag/Tag";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { trackEvents } from "@/common/events/events";
import ChangeAccountVerificationModal from "@/_MiniApps/auth/ui/ChangeAccountVerificationModal/ChangeAccountVerificationModal";
import { useTranslation } from "@i18n";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useButtonLoading from "@hooks/useButtonLoading";
import useApi from "@hooks/useApi";
import { api__getCitiesDropDown } from "@/apis/assets/api__get_cities_drop_down";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import useLocalStorage from "@hooks/useLocalStorage";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { toast } from "sonner";
import { ValidationException } from "@/common/exceptions/ValidationException";
import useIsMobile from "@hooks/useIsMobile";
import PromoTag from "@/_MiniApps/customized_promo_codes/components/PromoTag";
import { useEnhancedPromoSystem } from "@/_MiniApps/customized_promo_codes/hooks/useEnhancedPromoSystem";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import WarrantySection from "@/pages/checkout/warranty/WarrantySection";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import { REFERRER_REWARD_TYPE } from "@/pages/checkout/constants";
import useCookieClient from "@hooks/useCookieClient";
var getCurrentPostId = function getCurrentPostId() {
  return Number(new URLSearchParams(window.location.search).get("post_id") || new URLSearchParams(window.location.search).get("postId") || 0);
};
var showToast = function showToast(msg) {
  toast.success(msg, {
    position: "bottom-center",
    duration: 2000,
    style: {
      zIndex: 9999999
    }
  });
};
var showErrorToast = function showErrorToast(msg) {
  toast.error(msg, {
    position: "bottom-center",
    duration: 5000,
    style: {
      zIndex: 9999999
    }
  });
};
var getShopApplyFormStorageKey = function getShopApplyFormStorageKey(postId) {
  return "shop_apply_form_data_".concat(postId);
};
var getSessionFormData = function getSessionFormData(postId) {
  try {
    var id = postId || getCurrentPostId();
    if (!id) return {};
    var saved = sessionStorage.getItem(getShopApplyFormStorageKey(id));
    return saved ? JSON.parse(saved) : {};
  } catch (_unused) {
    return {};
  }
};
var ShopApplyForm = function ShopApplyForm(props) {
  var _formData$warranty_id, _checkoutOrderV2$g4_d4, _checkoutOrderV2$deta4, _checkoutOrderV2$deta5, _referralData$reward, _checkoutOrderV2$post2, _checkoutOrderV2$post3, _checkoutOrderV2$post4, _checkoutOrderV2$post5, _checkoutOrderV2$deta6;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLocalStorage = useLocalStorage(),
    setLocalStorage = _useLocalStorage.setLocalStorage;
  var location = useLocation();
  var isMobile = useIsMobile();
  var _useState = useState(null),
    validationException = _useState[0],
    setValidationException = _useState[1];
  var _useState2 = useState(false),
    showVerificationModal = _useState2[0],
    setShowVerificationModal = _useState2[1];
  var _useState3 = useState(null),
    promoFromUrl = _useState3[0],
    setPromoFromUrl = _useState3[1];
  var _useState4 = useState(false),
    hasUserStartedCheckoutForm = _useState4[0],
    setHasUserStartedCheckoutForm = _useState4[1];
  // Tracks whether a code has actually been activated (clicked تفعيل / restored),
  // not merely typed. Drives the activate/remove button label.
  var _useState5 = useState(false),
    codeApplied = _useState5[0],
    setCodeApplied = _useState5[1];
  var buttonLoading = useButtonLoading();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrderV2 = _useCheckoutOrder$sta.checkoutOrderV2,
    formData = _useCheckoutOrder$sta.formData,
    referralData = _useCheckoutOrder$sta.referralData,
    fetching_error = _useCheckoutOrder$sta.fetching_error,
    contextFormValidationException = _useCheckoutOrder$sta.formValidationException;
  var _useCheckoutOrder$que = useCheckoutOrder().queryParams,
    customerid = _useCheckoutOrder$que.customerid,
    referral = _useCheckoutOrder$que.referral,
    hasTawuniyaParams = _useCheckoutOrder$que.hasTawuniyaParams,
    post_id = _useCheckoutOrder$que.post_id;
  var _useCheckoutOrder$act = useCheckoutOrder().actions,
    setFormItem = _useCheckoutOrder$act.setFormItem,
    action__resetPromoCode = _useCheckoutOrder$act.action__resetPromoCode;
  var _useCheckoutOrder$rem = useCheckoutOrder().remote_actions,
    fetch__getPromoCodeV2 = _useCheckoutOrder$rem.fetch__getPromoCodeV2,
    fetch__createOrderV2 = _useCheckoutOrder$rem.fetch__createOrderV2,
    fetch__getOrderDetailsByParamsV2 = _useCheckoutOrder$rem.fetch__getOrderDetailsByParamsV2;
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var _useApi = useApi([], api__getCitiesDropDown),
    _useApi2 = _slicedToArray(_useApi, 3),
    loadingCities = _useApi2[0],
    errorCities = _useApi2[1],
    cities = _useApi2[2];
  var _useEnhancedPromoSyst = useEnhancedPromoSystem(),
    promoCode = _useEnhancedPromoSyst.promoCode,
    getPromoEventParams = _useEnhancedPromoSyst.getPromoEventParams,
    displayConfig = _useEnhancedPromoSyst.displayConfig;
  var allPromoCodes = promoCode ? [promoCode] : [];
  var sessionData = getSessionFormData(post_id);
  var _useForm = useForm({
      mode: "onBlur",
      defaultValues: {
        full_name: sessionData.full_name != null ? sessionData.full_name : (formData === null || formData === void 0 ? void 0 : formData.full_name) || "",
        phone_number: sessionData.phone_number != null ? sessionData.phone_number : (formData === null || formData === void 0 ? void 0 : formData.phone_number) || "",
        city_id: sessionData.city_id != null ? sessionData.city_id : user !== null && user !== void 0 && user.city_id ? String(user.city_id) : formData !== null && formData !== void 0 && formData.city_id ? String(formData.city_id) : "",
        code: sessionData.code != null ? sessionData.code : (formData === null || formData === void 0 ? void 0 : formData.code) || "",
        whatsapp_optin: sessionData.whatsapp_optin != null ? sessionData.whatsapp_optin : Number(formData === null || formData === void 0 ? void 0 : formData.whatsapp_optin) || 0,
        warranty_id: sessionData.warranty_id != null ? sessionData.warranty_id : (_formData$warranty_id = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id !== void 0 ? _formData$warranty_id : 0
      }
    }),
    control = _useForm.control,
    setValue = _useForm.setValue,
    watch = _useForm.watch,
    rhfHandleSubmit = _useForm.handleSubmit,
    setError = _useForm.setError,
    clearErrors = _useForm.clearErrors,
    rhfErrors = _useForm.formState.errors;

  // Guard to prevent watch from overwriting sessionStorage during initial mount
  var hasMounted = useRef(false);
  useEffect(function () {
    var timer = setTimeout(function () {
      hasMounted.current = true;
    }, 500);
    return function () {
      return clearTimeout(timer);
    };
  }, []);

  // Auto-save form values to sessionStorage on every change (except code)
  useEffect(function () {
    var subscription = watch(function (values) {
      if (!hasMounted.current) return;
      if (!post_id) return;
      try {
        var existing = getSessionFormData(post_id);
        var toSave = _objectSpread(_objectSpread(_objectSpread({}, existing), values), {}, {
          code: values.code || existing.code || "",
          warranty_id: values.warranty_id || existing.warranty_id || 0
        });
        sessionStorage.setItem(getShopApplyFormStorageKey(post_id), JSON.stringify(toSave));
      } catch (_unused2) {
        // sessionStorage full or unavailable
      }
    });
    return function () {
      return subscription.unsubscribe();
    };
  }, [watch, post_id]);

  // Sync sessionStorage data into checkout context on mount
  useEffect(function () {
    if (sessionData.full_name) setFormItem("full_name", sessionData.full_name);
    if (sessionData.phone_number) setFormItem("phone_number", sessionData.phone_number);
    if (sessionData.city_id) setFormItem("city_id", Number(sessionData.city_id));
    if (sessionData.code) {
      setFormItem("code", sessionData.code);
      setCodeApplied(true);
    }
    if (sessionData.whatsapp_optin != null) setFormItem("whatsapp_optin", sessionData.whatsapp_optin);
    if (sessionData.warranty_id) setFormItem("warranty_id", sessionData.warranty_id);
  }, []); // These only update context state, they don't trigger API calls

  useEffect(function () {
    var _checkoutOrderV2$g4_d, _props$setHasUserStar, _checkoutOrderV2$g4_d2, _checkoutOrderV2$g4_d3;
    if (!post_id || !(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) !== null && _checkoutOrderV2$g4_d !== void 0 && _checkoutOrderV2$g4_d.g4_data_layer)) return;
    if (!hasUserStartedCheckoutForm) return;
    (_props$setHasUserStar = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar === void 0 ? void 0 : _props$setHasUserStar.call(props, true);
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
    startAbandonmentTracking({
      key: "start_checkout_abandoned_cash_".concat(post_id),
      event: "start_checkout_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, checkoutOrderV2.g4_data.g4_data_layer), {}, {
        inventory_type: (_checkoutOrderV2$g4_d2 = checkoutOrderV2.g4_data.g4_data_layer) === null || _checkoutOrderV2$g4_d2 === void 0 ? void 0 : _checkoutOrderV2$g4_d2.inventory_type_string,
        post_trim: (_checkoutOrderV2$g4_d3 = checkoutOrderV2.g4_data.g4_data_layer) === null || _checkoutOrderV2$g4_d3 === void 0 ? void 0 : _checkoutOrderV2$g4_d3.post_ext,
        booking_type: "cash",
        last_completed_step: ''
      })
    });
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d4 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d4 === void 0 ? void 0 : _checkoutOrderV2$g4_d4.g4_data_layer, completeAbandonmentTracking, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking]);
  useEffect(function () {
    if (fetching_error) {
      showErrorToast(fetching_error.message);
    }
  }, [fetching_error]);
  var completeCashCheckoutAbandonmentTracking = function completeCashCheckoutAbandonmentTracking() {
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
    completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
  };
  var setFormItemProxy = function setFormItemProxy(key, value) {
    // Update form data and clear existing error for this field
    setFormItem(key, value);
    var rhfKey = key;
    clearErrors(rhfKey);
    setValue(rhfKey, value, {
      shouldDirty: true
    });
  };
  var getErrMsg = function getErrMsg(fieldName) {
    var _rhfErrors;
    return (rhfErrors === null || rhfErrors === void 0 ? void 0 : (_rhfErrors = rhfErrors[fieldName]) === null || _rhfErrors === void 0 ? void 0 : _rhfErrors.message) || (validationException === null || validationException === void 0 ? void 0 : validationException.extractErrorMessageFrom([fieldName])) || (contextFormValidationException === null || contextFormValidationException === void 0 ? void 0 : contextFormValidationException.extractErrorMessageFrom([fieldName]));
  };
  var validatePhoneNumber = function validatePhoneNumber(phone) {
    if (!phone) {
      return t("validation_mobile_number_chosen", {
        ns: "web_checkout_cash"
      });
    }
    if (!/^(05)[0-9]{8}$/.test(phone)) {
      return t("validation_mobile_number_consist_ten_numbers", {
        ns: "web_checkout_cash"
      });
    }
    return null;
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var _checkoutOrderV2$g4_d5;
      var phoneError, unbxdParams, _formData$warranty_id2, response, freshOrder, submission_source, promoCodedata, formValidationException, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            // Validate phone_number (not managed by CustomInputHookForm)
            phoneError = validatePhoneNumber(formData === null || formData === void 0 ? void 0 : formData.phone_number);
            if (!phoneError) {
              _context.n = 1;
              break;
            }
            setError("phone_number", {
              type: "manual",
              message: phoneError
            });
            return _context.a(2);
          case 1:
            if (!(!(formData !== null && formData !== void 0 && formData.city_id) || Number(formData.city_id) === 0)) {
              _context.n = 2;
              break;
            }
            setError("city_id", {
              type: "manual",
              message: "يجب اختيار المدينة"
            });
            return _context.a(2);
          case 2:
            if (!(isLoggedIn && (user === null || user === void 0 ? void 0 : user.phone_number) != (formData === null || formData === void 0 ? void 0 : formData.phone_number) && !showVerificationModal)) {
              _context.n = 3;
              break;
            }
            setShowVerificationModal(true);
            return _context.a(2);
          case 3:
            cashCheckout3Event(formData === null || formData === void 0 ? void 0 : formData.phone_number, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d5 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d5 === void 0 ? void 0 : _checkoutOrderV2$g4_d5.g4_data_layer);
            unbxdParams = {
              action: "cart",
              qty: "1",
              url: serverUrl + location.pathname + location.search,
              pid: post_id
            };
            unbxdAnalytics(unbxdParams);
            _context.p = 4;
            _context.n = 5;
            return fetch__createOrderV2();
          case 5:
            response = _context.v;
            if (!(!response || response.id == null)) {
              _context.n = 6;
              break;
            }
            showErrorToast(t("error_occurred_while_creating_request", {
              ns: "web_checkout_cash"
            }));
            return _context.a(2);
          case 6:
            // Cast to expected order type for successful response
            freshOrder = response; // Only proceed if we have a valid order with an ID
            if (freshOrder !== null && freshOrder !== void 0 && freshOrder.id) {
              _context.n = 7;
              break;
            }
            showErrorToast(t("error_occurred_while_creating_request", {
              ns: "web_checkout_cash"
            }));
            return _context.a(2);
          case 7:
            submission_source = getSubmissionSource();
            promoCodedata = getPromoEventParams(!(formData !== null && formData !== void 0 && formData.code) || (promoCode === null || promoCode === void 0 ? void 0 : promoCode.code) !== (formData === null || formData === void 0 ? void 0 : formData.code)); // Single full-order fetch sets context; OTP transition + analytics run inside
            // its onSuccess so they batch with setCheckoutOrderV2 → one render commit.
            // `order` is the full ICheckoutV2Data (carries detail + g4_data); the lean
            // create-v2 `response` only provides the id.
            _context.n = 8;
            return fetch__getOrderDetailsByParamsV2(Number(post_id), {
              city_id: formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined,
              code: (formData === null || formData === void 0 ? void 0 : formData.code) || undefined,
              warranty_id: (_formData$warranty_id2 = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id2 !== void 0 ? _formData$warranty_id2 : undefined
            }, function (order) {
              var _order$g4_data, _order$g4_data2, _order$g4_data2$g4_da, _order$detail, _order$g4_data3, _order$g4_data3$g4_da, _cities$find, _props$setCreatedOrde;
              setLocalStorage("otp_visited_".concat(response.id), "0");
              trackEvents("cash_form_submit", _objectSpread(_objectSpread({
                order_id: response === null || response === void 0 ? void 0 : response.id
              }, order === null || order === void 0 ? void 0 : (_order$g4_data = order.g4_data) === null || _order$g4_data === void 0 ? void 0 : _order$g4_data.g4_data_layer), {}, {
                post_trim: order === null || order === void 0 ? void 0 : (_order$g4_data2 = order.g4_data) === null || _order$g4_data2 === void 0 ? void 0 : (_order$g4_data2$g4_da = _order$g4_data2.g4_data_layer) === null || _order$g4_data2$g4_da === void 0 ? void 0 : _order$g4_data2$g4_da.post_ext,
                discount_code: (formData === null || formData === void 0 ? void 0 : formData.code) || null,
                total_amount: parseFloat(String((order === null || order === void 0 ? void 0 : (_order$detail = order.detail) === null || _order$detail === void 0 ? void 0 : _order$detail.total_amount) || "0").replace(/,/g, "")),
                inventory_type_string: order === null || order === void 0 ? void 0 : (_order$g4_data3 = order.g4_data) === null || _order$g4_data3 === void 0 ? void 0 : (_order$g4_data3$g4_da = _order$g4_data3.g4_data_layer) === null || _order$g4_data3$g4_da === void 0 ? void 0 : _order$g4_data3$g4_da.inventory_type_string,
                user_city: (_cities$find = cities.find(function (city) {
                  return city.id == (formData === null || formData === void 0 ? void 0 : formData.city_id);
                })) === null || _cities$find === void 0 ? void 0 : _cities$find.name_en,
                referral_location: submission_source
              }, promoCodedata));
              completeCashCheckoutAbandonmentTracking();
              (_props$setCreatedOrde = props.setCreatedOrderId) === null || _props$setCreatedOrde === void 0 ? void 0 : _props$setCreatedOrde.call(props, response.id);
              props.setShowOtp(true);
            });
          case 8:
            _context.n = 10;
            break;
          case 9:
            _context.p = 9;
            _t = _context.v;
            if (_t instanceof ValidationException) {
              formValidationException = _t;
              setValidationException(formValidationException);
              showErrorToast(formValidationException.getAllErrorMessages());
            } else {
              // Handle any other unexpected errors
              console.error('Order creation error:', _t);
              showErrorToast(t("error_unexpected_error_occurred_try_again", {
                ns: "web_checkout_cash"
              }));
            }
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[4, 9]]);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var activateTheCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(value) {
      var data, _formData$warranty_id3, existing;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return fetch__getPromoCodeV2(value);
          case 1:
            data = _context2.v;
            if (data && !data.status) {
              // Promo code is not valid - use error message from API response if available
              setError("code", {
                type: "manual",
                message: (data === null || data === void 0 ? void 0 : data.error) || t("كود الخصم غير صالح", {
                  ns: "web_checkout_cash"
                })
              });
              setTimeout(function () {
                clearErrors("code");
              }, 3000);
            } else {
              setCodeApplied(true);
              // Save code to sessionStorage only on successful activation
              try {
                existing = getSessionFormData(post_id);
                sessionStorage.setItem(getShopApplyFormStorageKey(post_id), JSON.stringify(_objectSpread(_objectSpread({}, existing), {}, {
                  code: value
                })));
              } catch (_unused3) {
                // sessionStorage full or unavailable
              }
              fetch__getOrderDetailsByParamsV2(getCurrentPostId(), {
                city_id: formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined,
                code: value,
                warranty_id: (_formData$warranty_id3 = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id3 !== void 0 ? _formData$warranty_id3 : undefined
              });
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function activateTheCode(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (user) {
      // Re-read sessionStorage inside effect to get fresh data
      var currentSessionData = getSessionFormData(post_id);
      // Only set user data if there's no saved session data for these fields
      if (currentSessionData.full_name == null) {
        setFormItem("full_name", user === null || user === void 0 ? void 0 : user.full_name);
        setValue("full_name", (user === null || user === void 0 ? void 0 : user.full_name) || "");
      }
      if (currentSessionData.phone_number == null) {
        setFormItem("phone_number", user === null || user === void 0 ? void 0 : user.phone_number);
        setValue("phone_number", (user === null || user === void 0 ? void 0 : user.phone_number) || "");
      }
      if (currentSessionData.city_id == null && user !== null && user !== void 0 && user.city_id) {
        setFormItem("city_id", user.city_id);
        setValue("city_id", String(user.city_id));
      }
    }
    if (hasTawuniyaParams) {
      setFormItem("referral", referral);
      setFormItem("customerid", customerid);
    }
  }, [user]);

  // SE-12392: city_id resolved from the API (post.city_id) lands in formData after mount,
  // so the RHF default value misses it and the dropdown renders blank. Sync it into the
  // dropdown once the field is still empty (don't clobber a user/session selection).
  useEffect(function () {
    if (!(formData !== null && formData !== void 0 && formData.city_id) || Number(formData.city_id) === 0) return;
    var current = watch("city_id");
    if (current && String(current) !== "0" && String(current) !== "") return;
    setValue("city_id", String(formData.city_id));
  }, [formData === null || formData === void 0 ? void 0 : formData.city_id]);

  // Keep RHF warranty_id in sync with context. The desktop warranty selector (PaymentInfoV2
  // in ShopApply) updates formData.warranty_id via setFormItem only — it can't reach this form's
  // RHF state. Without this sync, RHF holds the stale value and the watch auto-save below rewrites
  // sessionStorage with the old warranty_id, so a changed selection never persists.
  useEffect(function () {
    if ((formData === null || formData === void 0 ? void 0 : formData.warranty_id) == null) return;
    if (Number(watch("warranty_id")) === Number(formData.warranty_id)) return;
    setValue("warranty_id", Number(formData.warranty_id));
  }, [formData === null || formData === void 0 ? void 0 : formData.warranty_id]);
  var isPromoTagVisible = checkFeatureFlag("FE_CUTOMIZED_PROMO_CODE") && displayConfig.showTag;
  useEffect(function () {
    // SE-11902: only run for an actual URL promo — promoFromUrl starts null and this
    // effect would otherwise wipe a restored/persisted code on mount.
    if (!promoFromUrl) return;
    setFormItem("code", promoFromUrl);
    setValue("code", promoFromUrl);
    // Auto-activate the code
    setTimeout(function () {
      activateTheCode(promoFromUrl);
    }, 100);
  }, [promoFromUrl]);
  useEffect(function () {
    var _checkoutOrderV2$deta, _checkoutOrderV2$deta2, _checkoutOrderV2$deta3;
    // Auto-apply promo code from URL if present, and check it if valid or not
    var urlParams = new URLSearchParams(location.search);
    var code = urlParams.get('promo');
    if (!promoFromUrl && !(formData !== null && formData !== void 0 && formData.code) && code && (isPromoTagVisible || (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$deta = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta === void 0 ? void 0 : (_checkoutOrderV2$deta2 = _checkoutOrderV2$deta.discounts) === null || _checkoutOrderV2$deta2 === void 0 ? void 0 : _checkoutOrderV2$deta2.length) > 0 && checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$deta3 = checkoutOrderV2.detail) !== null && _checkoutOrderV2$deta3 !== void 0 && _checkoutOrderV2$deta3.discounts.find(function (discount) {
      return discount.code === code;
    }))) {
      setPromoFromUrl(urlParams.get('promo'));
    }
  }, [location.search, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$deta4 = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta4 === void 0 ? void 0 : _checkoutOrderV2$deta4.discounts]);
  useEffect(function () {
    var _checkoutOrderV2$post;
    document.title = "".concat(t("details_review", {
      ns: "web_checkout_cash"
    }), "  ").concat((checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post = checkoutOrderV2.post) === null || _checkoutOrderV2$post === void 0 ? void 0 : _checkoutOrderV2$post.post_title) || "");
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: props.style ? props.style : undefined,
    className: [stl.container, props.loading ? stl.formLoad : undefined].join(" ")
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: ["textLoading textLoadingPage", stl.posAbs].join(" ")
  }), isMobile && /*#__PURE__*/React.createElement(MobileCarInfoV2, {
    className: "mt-5 mb-6",
    checkoutOrderV2: checkoutOrderV2,
    onClickInfoIcon: props.onClickInfoIcon
  }), isMobile && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(WarrantySection, {
    checkoutOrderV2: checkoutOrderV2,
    orderType: "cash",
    referralLocation: "checkout",
    warranty_promo_code_enabled: (referralData === null || referralData === void 0 ? void 0 : referralData.type) === REFERRER_REWARD_TYPE.WARRANTY,
    onWarrantyChange: (/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              setFormItemProxy("warranty_id", id);
              _context3.n = 1;
              return fetch__getOrderDetailsByParamsV2(getCurrentPostId(), {
                city_id: formData !== null && formData !== void 0 && formData.city_id ? Number(formData.city_id) : undefined,
                warranty_id: id,
                code: (formData === null || formData === void 0 ? void 0 : formData.code) || undefined
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }())
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.hdr
  }, t("add_information", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("form", {
    onSubmit: rhfHandleSubmit(function () {
      return handleSubmit();
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CustomInputHookForm, {
    id: "checkout-fullname-input",
    name: "full_name",
    control: control,
    rules: {
      required: t("validation_name_filled", {
        ns: "web_checkout_cash"
      }),
      minLength: {
        value: 5,
        message: t("validation_name_5_characters", {
          ns: "web_checkout_cash"
        })
      },
      pattern: {
        value: /^[\u0600-\u06FFa-zA-Z\s]+$/,
        message: t("validation_name_contain_symbols_unsupported_characters", {
          ns: "web_checkout_cash"
        })
      }
    },
    className: stl.rowData,
    label: t("full_name", {
      ns: "web_checkout_cash"
    }),
    type: "text",
    placeholder: t("full_name_2", {
      ns: "web_checkout_cash"
    }),
    onValueChange: function onValueChange(value) {
      var _props$setHasUserStar2;
      setHasUserStartedCheckoutForm(true);
      (_props$setHasUserStar2 = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar2 === void 0 ? void 0 : _props$setHasUserStar2.call(props, true);
      setFormItemProxy("full_name", value);
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputPhoneNumber, {
    id: "checkout-phone-input",
    className: stl.rowData,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.phone_number,
    onChange: function onChange(value) {
      var _props$setHasUserStar3;
      setHasUserStartedCheckoutForm(true);
      (_props$setHasUserStar3 = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar3 === void 0 ? void 0 : _props$setHasUserStar3.call(props, true);
      setFormItemProxy("phone_number", value);
      setValue("phone_number", value);
    },
    onBlur: function onBlur() {
      var phoneError = validatePhoneNumber(formData === null || formData === void 0 ? void 0 : formData.phone_number);
      if (phoneError) {
        setError("phone_number", {
          type: "manual",
          message: phoneError
        });
      } else {
        clearErrors("phone_number");
      }
    },
    errorLabel: getErrMsg("phone_number"),
    errorLabelClassName: ""
  }), /*#__PURE__*/React.createElement("label", {
    className: stl.whtsFlx
  }, /*#__PURE__*/React.createElement("input", {
    onChange: function onChange(target) {
      var new_value = formData !== null && formData !== void 0 && formData.whatsapp_optin ? 0 : 1;
      setFormItemProxy("whatsapp_optin", new_value);
    },
    defaultChecked: formData === null || formData === void 0 ? void 0 : formData.whatsapp_optin,
    type: "checkbox",
    name: "whatsapp_optin"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.boxDummy
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whts",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("like_communicate_receive_update_updates", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement(CustomInputHookForm, {
    id: "checkout-city-select",
    name: "city_id",
    control: control,
    rules: {
      required: "يجب اختيار المدينة",
      validate: function validate(value) {
        return value && String(value) !== "0" && String(value) !== "" || "يجب اختيار المدينة";
      }
    },
    className: stl.rowData,
    label: t("city", {
      ns: "web_checkout_cash"
    }),
    type: "select",
    onValueChange: function onValueChange(value) {
      var _props$setHasUserStar4, _formData$warranty_id4;
      setHasUserStartedCheckoutForm(true);
      (_props$setHasUserStar4 = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar4 === void 0 ? void 0 : _props$setHasUserStar4.call(props, true);
      setFormItemProxy("city_id", Number(value));
      fetch__getOrderDetailsByParamsV2(getCurrentPostId(), {
        city_id: Number(value),
        warranty_id: (_formData$warranty_id4 = formData === null || formData === void 0 ? void 0 : formData.warranty_id) !== null && _formData$warranty_id4 !== void 0 ? _formData$warranty_id4 : undefined,
        code: formData.code
      }, function (order) {
        var _order$sections;
        // Skip the "shipping cost updated" toast when the shipping
        // section carries a note (show_note) — the note already
        // explains shipping, so the toast is redundant.
        var hasShippingNote = order === null || order === void 0 ? void 0 : (_order$sections = order.sections) === null || _order$sections === void 0 ? void 0 : _order$sections.filter(function (s) {
          var _s$key;
          return (_s$key = s.key) === null || _s$key === void 0 ? void 0 : _s$key.includes("shipping");
        }).flatMap(function (s) {
          var _s$items;
          return (_s$items = s.items) !== null && _s$items !== void 0 ? _s$items : [];
        }).some(function (item) {
          return item.show_note;
        });
        if (hasShippingNote) return;
        showToast(t("shipping_cost_updated", {
          ns: "web_checkout_cash"
        }));
      });
    },
    options: cities && [{
      name: t("select", {
        ns: "web_checkout_finance"
      }),
      id: ""
    }].concat(_toConsumableArray(cities))
  }), /*#__PURE__*/React.createElement("p", {
    className: "".concat(stl.smallNote, " ").concat(rhfErrors !== null && rhfErrors !== void 0 && rhfErrors.city_id ? stl.pt10 : "")
  }, t("shipping_cost_city_added_total", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("hr", {
    className: "".concat(stl.hr, " m-hide")
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.codeContainer
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.subHdr
  }, t("discount_code", {
    ns: "web_checkout_cash"
  })), isPromoTagVisible && /*#__PURE__*/React.createElement(PromoTag, {
    tags: allPromoCodes,
    value: formData === null || formData === void 0 ? void 0 : formData.code,
    onClick: function onClick(value) {
      setFormItemProxy("code", value);
      activateTheCode(value);
    },
    withPopUp: true
  }), (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$deta5 = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta5 === void 0 ? void 0 : _checkoutOrderV2$deta5.discounts) && checkoutOrderV2.detail.discounts.length > 0 && /*#__PURE__*/React.createElement(Tag, {
    selectedTag: function selectedTag(target) {
      setFormItemProxy("code", target === null || target === void 0 ? void 0 : target.code);
    },
    tags: checkoutOrderV2.detail.discounts,
    value: formData === null || formData === void 0 ? void 0 : formData.code,
    onClick: function onClick(value) {
      setFormItemProxy("code", value);
      activateTheCode(value);
    },
    withPopUp: true
  }), /*#__PURE__*/React.createElement(CustomInputHookForm, {
    id: "checkout-promo-input",
    buttonId: "checkout-apply-promo-btn",
    errorId: "checkout-promo-error",
    name: "code",
    control: control,
    className: stl.rowData,
    label: t("discount_code_2", {
      ns: "web_checkout_cash"
    }),
    type: "text",
    placeholder: t("enter_discount_code", {
      ns: "web_checkout_cash"
    }),
    hasButton: true,
    buttonText: t("activate", {
      ns: "web_checkout_cash"
    }),
    ErrorInCode: !!getErrMsg("code"),
    ErrorMsg: getErrMsg("code"),
    resetCode: function resetCode() {
      action__resetPromoCode();
      setCodeApplied(false);
      setValue("code", "");
      try {
        var existing = getSessionFormData(post_id);
        delete existing.code;
        sessionStorage.setItem(getShopApplyFormStorageKey(post_id), JSON.stringify(existing));
      } catch (_unused4) {}
    },
    onValueChange: function onValueChange(value) {
      setFormItemProxy("code", value);
      setCodeApplied(false);
      if (!value) {
        action__resetPromoCode();
        try {
          var existing = getSessionFormData(post_id);
          delete existing.code;
          sessionStorage.setItem(getShopApplyFormStorageKey(post_id), JSON.stringify(existing));
        } catch (_unused5) {}
      }
    },
    buttonFunction: function buttonFunction() {
      return activateTheCode(formData === null || formData === void 0 ? void 0 : formData.code);
    },
    isValid: (referralData === null || referralData === void 0 ? void 0 : referralData.status) || codeApplied,
    referralMsg: referralData === null || referralData === void 0 ? void 0 : (_referralData$reward = referralData.reward) === null || _referralData$reward === void 0 ? void 0 : _referralData$reward.title
  })), (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.post_is_new) != 1 && (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post3 = checkoutOrderV2.post) === null || _checkoutOrderV2$post3 === void 0 ? void 0 : _checkoutOrderV2$post3.is_warranty_10_day) && /*#__PURE__*/React.createElement(NDayGuarantee, {
    className: "m-show",
    img: CDN_LINK + "/assets/images/dm10.svg"
  }), (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post4 = checkoutOrderV2.post) === null || _checkoutOrderV2$post4 === void 0 ? void 0 : _checkoutOrderV2$post4.post_is_new) == 1 && /*#__PURE__*/React.createElement("p", {
    className: [stl.smallNote, stl.noteBtm].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, t("notice", {
    ns: "web_checkout_cash"
  })), t("paying_down_payment_reserve_car", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: [stl.smallNote, stl.noteBtm].join(" ")
  }, !(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post5 = checkoutOrderV2.post) !== null && _checkoutOrderV2$post5 !== void 0 && _checkoutOrderV2$post5.post_is_new) && t("down_payment_fully_refundable_registration_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.contBtnContainer
  }, /*#__PURE__*/React.createElement("button", {
    id: "checkout-submit-btn",
    type: "submit",
    className: "greenBtn",
    disabled: buttonLoading
  }, /*#__PURE__*/React.createElement("strong", null, t("continue_down_payment", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$deta6 = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta6 === void 0 ? void 0 : _checkoutOrderV2$deta6.arboun, /*#__PURE__*/React.createElement("span", {
    className: "text-lg"
  }, t("sar", {
    ns: "web_checkout_cash"
  }))))))), /*#__PURE__*/React.createElement(ChangeAccountVerificationModal, {
    show: showVerificationModal,
    onClose: function onClose() {
      return setShowVerificationModal(false);
    },
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setShowVerificationModal(false);
            _context4.n = 1;
            return logout(null);
          case 1:
            handleSubmit();
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    })),
    newPhoneNumber: formData === null || formData === void 0 ? void 0 : formData.phone_number,
    loading: buttonLoading
  }));
};
export default ShopApplyForm;